import { ApolloQueryResult } from '@apollo/client';
import React from 'react';

import { GetAppConfigQuery } from '@ocx/graphql';

import { MembershipConfigOverrides, RuntimeConfig } from './app-config.types';

export type IConfigurationContextValue = {
  error: unknown;
  loaded: boolean;
  config: RuntimeConfig | null;
  setMembershipOverrides(overrides: MembershipConfigOverrides | null): void;
  refetch(): Promise<ApolloQueryResult<GetAppConfigQuery>>;
};

export const ConfigurationContext = React.createContext<IConfigurationContextValue | null>(null);
